import { type Icon, SvgIcon, tw } from "@sveabank/cc-common";

type Props = {
	icon: Icon;
	isCompleted?: boolean;
};

export const IconWithCircle = ({ icon, isCompleted = false }: Props) => {
	return (
		<div
			className={tw(
				"border-interactive-secondary tablet:size-20 tablet:p-5 size-14 shrink-0 grow-0 rounded-full border-2 border-solid p-4 align-top",
				isCompleted && "border-sds-border-success bg-sds-surface-success",
			)}
			aria-hidden="true"
		>
			<SvgIcon
				imageSrc={icon}
				height="auto"
				className={isCompleted ? "text-sds-icon-success" : "text-interactive-secondary"}
			/>
		</div>
	);
};
